import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/team/title1.png'
import _imports_1 from '@/assets/image/team/title2.png'


const _withScopeId = n => (_pushScopeId("data-v-2bbb96a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-index" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img1",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "img2",
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tag" }
const _hoisted_6 = { class: "name mt20" }
const _hoisted_7 = { class: "c-name" }
const _hoisted_8 = { class: "e-name" }
const _hoisted_9 = { class: "desc" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about" }, null, -1))
const _hoisted_12 = { class: "flex2" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "img" }
const _hoisted_15 = { class: "tag" }
const _hoisted_16 = { class: "r-desc" }
const _hoisted_17 = { class: "name" }
const _hoisted_18 = { class: "c-name" }
const _hoisted_19 = { class: "e-name" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about" }, null, -1))
const _hoisted_21 = { class: "desc" }
const _hoisted_22 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex-item",
          key: idx,
          onClick: ($event: any) => (_ctx.detail(item.id))
        }, [
          _createElementVNode("div", {
            class: "img",
            style: _normalizeStyle({backgroundImage:`url(${item.img})`,})
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.tag), 1)
          ], 4),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(item.name), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(item.english), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(item.desc), 1)
          ]),
          _hoisted_11
        ], 8, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex-item",
          key: idx,
          style: _normalizeStyle({ margin: _ctx.margin }),
          onClick: ($event: any) => (_ctx.detail(item.id))
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "bg",
              style: _normalizeStyle({backgroundImage:`url(${item.img})`})
            }, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(item.tag), 1)
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(item.name), 1),
                _createElementVNode("p", _hoisted_19, _toDisplayString(item.english), 1)
              ]),
              _hoisted_20
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", _hoisted_22, _toDisplayString(item.desc), 1)
            ])
          ])
        ], 12, _hoisted_13))
      }), 128))
    ])
  ]))
}